import http from "@/settings/apiSettings";

class ERP_ParametriDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/ERP_Parametri", data);
    }

    update(id: string, data: any): Promise<any> {
        return http.clientComercialOdata.patch(`/ERP_Parametri(${id})`, data);
    }

    delete(id: string): Promise<any> {
        return http.clientComercialOdata.delete(`/ERP_Parametri(${id})`);
    }
}

export default new ERP_ParametriDataService();
